import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { DATE_PICKER_MODE_AM, DATE_PICKER_MODE_PM } from '../constants';
import { TimeVector12 } from './TimeVector12';
export var TimeVector24 = /*#__PURE__*/function () {
  function TimeVector24() {
    var hour = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var minute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _classCallCheck(this, TimeVector24);
    this.hour = hour;
    this.minute = minute;
  }
  _createClass(TimeVector24, [{
    key: "convertTo12",
    value: function convertTo12() {
      var hour = this.hour,
        minute = this.minute;
      var resultHour = hour;
      var mode = DATE_PICKER_MODE_AM;
      if (hour === 0) {
        resultHour = 12;
      } else if (hour === 12) {
        mode = DATE_PICKER_MODE_PM;
      } else if (hour > 12 && hour <= 23) {
        resultHour = hour - 12;
        mode = DATE_PICKER_MODE_PM;
      }
      return new TimeVector12(resultHour, minute, mode);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var hour = this.hour,
        minute = this.minute;
      return {
        hour: hour,
        minute: minute
      };
    }
  }, {
    key: "formattedHour",
    get: function get() {
      return this.hour.toString();
    }
  }, {
    key: "formattedMinute",
    get: function get() {
      return this.minute.toString().padStart(2, '0');
    }
  }, {
    key: "clone",
    value: function clone() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        hour = _ref.hour,
        minute = _ref.minute;
      return new TimeVector24(hour === undefined ? this.hour : hour, minute === undefined ? this.minute : minute);
    }
  }], [{
    key: "createFromDateVector",
    value: function createFromDateVector(dateVector) {
      return new this(dateVector.hour, dateVector.minute);
    }
  }]);
  return TimeVector24;
}();